import * as React from 'react';

import ReliableRequest from '../../../lib/ReliableRequest';
import { ChatStatus } from './ChatStatus';

const POLL_INTERVAL_MS = 10000;
const POLL_DELAY_MS = 1000;

export interface ChatHeaderProps {
  sessionId: string;
  startTime: Date;
  chatStatus: ChatStatus;
  agent: string;
}

export class WebsiteWidgetChatHeader extends React.Component<ChatHeaderProps> {
  state = {
    queuePosition: null,
  }

  private timeout: number;

  pollQueuePosition = () => {
    const { sessionId } = this.props;
    ReliableRequest.dispatch({
      url: `${window.location.pathname}/queue_position`,
      method: 'GET',
      data: { live_session: sessionId },
      whitelist: [400, 500],
      onSuccess: ({ queue_position }) => {
        this.setState({
          queuePosition: queue_position,
        });
        this.timeout = window.setTimeout(this.pollQueuePosition, POLL_INTERVAL_MS);
      },
      setTimeout: (cb, ms) => {
        this.timeout = window.setTimeout(cb, ms);
      },
    });
  }

  componentDidMount() {
    const { chatStatus } = this.props;
    if (chatStatus !== ChatStatus.UNASSIGNED) return;
    // We delay the initial request because there's a delay before the ticket is created and immediate request returns 404.
    this.timeout = window.setTimeout(this.pollQueuePosition, POLL_DELAY_MS);
  }

  componentDidUpdate(prevProps) {
    const { chatStatus } = this.props;
    if (chatStatus === prevProps.chatStatus) return;
    if (chatStatus === ChatStatus.UNASSIGNED) this.timeout = window.setTimeout(this.pollQueuePosition, POLL_DELAY_MS);
    else clearTimeout(this.timeout);
  }

  componentWillUnmount() {
    clearTimeout(this.timeout);
  }

  renderQueueStatus() {
    const { chatStatus } = this.props;
    if (chatStatus !== ChatStatus.UNASSIGNED) return null;
    const { queuePosition } = this.state;
    if (typeof queuePosition !== 'number') return null;

    return (
      <>
        <br />
        {queuePosition > 0
          ? `There ${queuePosition === 1 ? 'is 1 person' : `are ${queuePosition} people`} ahead of you in line.`
          : 'You are the first person in line.'}
      </>
    );
  }

  render() {
    const { startTime, chatStatus, agent = 'an agent' } = this.props;

    let headerText = 'Thank you for choosing to chat with us.';
    let agentStatus: string;

    if (chatStatus === ChatStatus.UNASSIGNED) {
      agentStatus = 'An agent will be with you shortly.';
    } else if (chatStatus === ChatStatus.OPEN) {
      agentStatus = `Now chatting with ${agent}`;
    } else {
      agentStatus = 'Please create a new chat session if you need additional help. Thank you.';
      headerText = 'This conversation has ended.';
    }

    return (
      <div className="center preamble">
        <div className="convo-start-time">
          <time dateTime={startTime.toISOString()} data-local="time" data-format="%b %e, %l:%M %p" />
        </div>
        {headerText}
        <br />
        <span id="current-agent-status">{agentStatus}</span>
        {this.renderQueueStatus()}
      </div>
    );
  }
}
